import _slicedToArray from "/home/runner/work/kraftgatsby/kraftgatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "./index.css";
import { jsx as $hgUW1$jsx } from "react/jsx-runtime";
import { useState as $hgUW1$useState, useMemo as $hgUW1$useMemo, useEffect as $hgUW1$useEffect } from "react";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $0de4af030c812050$exports = {};
$parcel$export($0de4af030c812050$exports, "pageScroll", function () {
  return $0de4af030c812050$export$b17a96fcfd4ef908;
}, function (v) {
  return $0de4af030c812050$export$b17a96fcfd4ef908 = v;
});
var $0de4af030c812050$export$b17a96fcfd4ef908;
$0de4af030c812050$export$b17a96fcfd4ef908 = "b5_jqa_pageScroll";

var $dc0014a2d0f0ac28$export$b5450e75fc4994df = function $dc0014a2d0f0ac28$export$b5450e75fc4994df(_ref) {
  var container = _ref.container,
      color = _ref.color,
      bgColor = _ref.bgColor,
      height = _ref.height,
      top = _ref.top;

  var _ref2 = (0, $hgUW1$useState)(0),
      _ref3 = _slicedToArray(_ref2, 2),
      scrollPosition = _ref3[0],
      setscrollPosition = _ref3[1];

  var cssStyles = (0, $hgUW1$useMemo)(function () {
    return {
      "--page-scroll-bar-color": color || "#eb5757",
      "--page-scroll-background-color": bgColor || "#f2f2f2",
      "--page-scroll-height": height || "0.25rem",
      "--top": top || "0"
    };
  }, [color, bgColor, height, top]);

  var handleScroll = function handleScroll() {
    var scrollYHeight = window.scrollY;
    var viewPortHeight = document.documentElement.clientHeight;
    var appHeight;
    if (container) appHeight = container === null || container === void 0 ? void 0 : container.clientHeight;else appHeight = document.body.clientHeight;
    var percent = scrollYHeight * 100 / (appHeight - viewPortHeight);
    setscrollPosition(percent);
  };

  (0, $hgUW1$useEffect)(function () {
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return /*#__PURE__*/(0, $hgUW1$jsx)("progress", {
    className: (0, /*@__PURE__*/$parcel$interopDefault($0de4af030c812050$exports)).pageScroll,
    style: cssStyles,
    id: "top-scroll-bar",
    "data-testid": "top-scroll-bar",
    value: scrollPosition,
    max: 100
  });
};

var $dc0014a2d0f0ac28$export$2e2bcd8739ae039 = $dc0014a2d0f0ac28$export$b5450e75fc4994df;
var $149c1bd638913645$export$2e2bcd8739ae039 = (0, $dc0014a2d0f0ac28$export$2e2bcd8739ae039);
export { $149c1bd638913645$export$2e2bcd8739ae039 as default };